import { PluginEvent, PluginEventType, PluginDomEvent } from 'roosterjs-editor-types';

export default function inlineImageCropPluginTrigger(evt: PluginEvent): boolean {
    if (evt.eventType == PluginEventType.MouseUp) {
        const domElement = <Element>(<PluginDomEvent>evt).rawEvent.target;
        if (domElement?.nodeName == 'IMG') {
            return true;
        }
    }
    return false;
}
